import type { ApiError } from "@fleetlease/shared";
import { config } from "./config";

// In prod the SPA calls the API Gateway URL directly (CORS is open on the API).
// Locally, fall back to the vite proxy at /api.
const BASE = config.apiUrl || "/api";

export async function apiFetch<T>(path: string, init?: RequestInit & { token?: string | null }): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.token ? { authorization: `Bearer ${init.token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw data as ApiError;
  return data as T;
}
